import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';

function formatLeft(ms) {
    if (ms <= 0) return 'vencido';
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
}

export default function SLAChip({ dueAt }) {
    const target = dueAt ? new Date(dueAt).getTime() : null;
    const [left, setLeft] = useState(target ? target - Date.now() : null);

    useEffect(() => {
        if (!target) return;
        const id = setInterval(() => setLeft(target - Date.now()), 30000);
        return () => clearInterval(id);
    }, [target]);

    if (!target) return <Badge bg="secondary">sin SLA</Badge>;
    const ms = left ?? (target - Date.now());
    const negative = ms <= 0;
    const variant = negative ? 'danger' : ms < 3600000 ? 'warning' : 'success';
    return <Badge bg={variant}>{negative ? '⏰ vencido' : `⏳ ${formatLeft(ms)}`}</Badge>;
}
